export const PLAYLIST = [
    {
        title: "Eternal Sunshine",
        artist: "Ariana Grande",
    },
    {
        title: "Bridges",
        artist: "Fifth Harmony"
    },
    {
        title: "I Know Alone",
        artist: "HAIM"
    },
    {
        title: "Expectations",
        artist: "Lauren Jauregui"
    },
    {
        title: "When Doves Cry",
        artist: "Prince"
    },
    {
        title: "Tantrums",
        artist: "Normani",
    },
    {
        title: "II HANDS II HEAVEN",
        artist: "Beyoncé"
    },
    {
        title: "Gone to Bed",
        artist: "Ally Brooke"
    },
    {
        title: "The Other Side",
        artist: "Jazmine Sullivan"
    },
    {
        title: "Fix It",
        artist: "Dinah Jane"
    },
    {
        title: "B2b",
        artist: "Charli XCX"
    },
    {
        title: "No Doubt",
        artist: "Camila Cabello"
    },
]
